<template>
    <div>
        <p class='title' style='margin: 20px 0 10px; font-size: 18px; color: #FF6464;'>账号视频作品分析</p>
        <el-card class="box-card">
            <div slot="header" class="clearfix">
                <span>数据分析</span>
                <el-button style="float: right; padding: 3px 0" type="text" @click='lookMore'>查看更多</el-button>
            </div>
            <el-table
                :data="infoData.result_list"
                style="width: 100%">
                <el-table-column prop="date" label="日期" width="180"></el-table-column>
                <el-table-column prop="new_transmit" label="每日新增视频播放"></el-table-column>
                <el-table-column prop="total_content" label="每日内容总数"></el-table-column>
                <el-table-column prop="new_content" label="每日发布内容数"></el-table-column>
                <el-table-column prop="sum_fans" label="每日总粉丝数"></el-table-column>
                <el-table-column prop="fresh_fans" label="每天新粉丝数"></el-table-column>
                <el-table-column prop="fresh_like" label="每日新增点赞"></el-table-column>
                <el-table-column prop="add_comment" label="每日新增评论"></el-table-column>
                <el-table-column prop="add_share" label="每日新增分享"></el-table-column>
                <el-table-column prop="people_visit" label="每日抖音主页访客数" width="100"></el-table-column>
            </el-table>
        </el-card>

        <!-- 粉丝列表 -->
        <info-fan-list :info-data='info' @lookMore='lookMore' />

        <!-- 关注列表 -->
        <info-attention-list :info-data='info' @lookMore='lookMore' />
    </div>
</template>

<script>
import InfoFanList from './InfoFanList';
import InfoAttentionList from './InfoAttentionList'

export default {
    props: {
        infoData: {
            type: Object,
            default() {
                return {}
            }
        }
    },
    components: {
        InfoFanList,
        InfoAttentionList,
    },
    computed: {
        info() {
            return this.infoData
        }
    },
    methods: {
        lookMore() {
            this.$alert('如需获取更多数据请联系客服', '提示', {
                confirmButtonText: '确定',
                callback: action => {
                }
            });
        },
    }
}
</script>

<style scoped>

</style>
